import React from 'react';
import { connect } from 'react-redux';

import UsersList from './infoComponents/usersList';
import DescriptionInfo from './infoComponents/descriptionInfo';
import ProtocolInfo from './infoComponents/protocolInfo';
import CustomcardfieldInfo from './infoComponents/customcardfieldInfo';
import SignaturesInfo from './infoComponents/signaturesInfo';


class CardInfo extends React.Component{

    render(){
        let customcardId = this.props.cardsGroup.attributes.customcard_id
        let customcard = null
        const customcardfieldComponents = [];
        if (customcardId) {
            customcard = this.props.projectData.customcards[customcardId.toString()]
            for (const customcardfieldData of Object.values(customcard.customcardfields)) {
                if (customcardfieldData.attributes.reference_field === 'description') {
                    customcardfieldComponents.push(
                        <CustomcardfieldInfo card={this.props.card} cardsGroup={this.props.cardsGroup} customcardfield={customcardfieldData}/>
                    ); 
                }
            }
        }

        return (
            <div>
                { this.props.card &&  
                    <div>
                        <DescriptionInfo 
                            card={this.props.card} 
                            customcard={customcard}/> 
                    </div>
                }
                <ProtocolInfo 
                    card={this.props.card} 
                    cardsGroup={this.props.cardsGroup} 
                    customcard={customcard}
                    protocolgroups={this.props.projectData.protocolgroups}/>
                { this.props.card && 
                    <UsersList 
                        card={this.props.card}
                        customcard={customcard}/>
                }
                {customcardfieldComponents}
                { this.props.card && 
                    <SignaturesInfo 
                        cardId={this.props.card.id}
                        cardsGroup={this.props.cardsGroup} usersData={this.props.projectUsers}/>
                }
            </div> 
        );

    }
}

function mapStateToProps( state ){
    return {
        popup : state.popup,
        projectData : state.projectData,
        projectUsers : state.projectUsers,
    }
}

export default connect(mapStateToProps)(CardInfo);